import { ConfigCampoFiltro, configDeCampos } from '../models/configCampoFiltro.model.js';
import { InputButtonSelectorConfig } from '../models/InputButtonSelectorConfig.model.js';
import { InputCheckboxFieldsConfig } from '../models/InputCheckboxFieldsConfig.model.js';
import { formatPeriodoConclusao, formatSearchString } from '../utils/filter.utils';
import { InputButtonConfig } from '../models/InputButtonConfig.model.js';
import { dateUtils } from '../../../util/date.utils';

export const defaultIlikeTextField = (key, id = 'text-filtro', label = "Nome", placeholder = "Digite...") => {
    if (!key) return;
    const textFiltro = new ConfigCampoFiltro(
        new configDeCampos(id, 'text', key, `${key}[iLike]`)
      );
      textFiltro.containerOptions.containerClasses = {
        ...textFiltro.containerOptions.containerClasses,
        'is-3': false,
        'is-4': true,
        'is-12-mobile': true
      }
      textFiltro.configuracoesDeInput.placeholder = placeholder;
      textFiltro.configuracoesDeInput.label = label;
      textFiltro.configuracoesDeCampo.formatter = formatSearchString
      return textFiltro
}

export const defaultButtonSelectorIntervalField = (key, id = 'button-selector-intervalo-filtro', label = "Intervalo") => {
    if (!key) return;
    const buttonSelectorFiltro = new ConfigCampoFiltro(
        new configDeCampos(id, 'button-selector', key, key)
      );
      buttonSelectorFiltro.containerOptions.containerClasses = {
        ...buttonSelectorFiltro.containerOptions.containerClasses,
        'is-3': false,
        'is-narrow': true,
        'is-12-mobile': true
      }
      const buttonSelectorConfig = new InputButtonSelectorConfig(buttonSelectorFiltro.configuracoesDeInput);
      buttonSelectorConfig.options = [
        {
          id: "btn-filtro-intervalo-hoje",
          label: "Hoje",
          isSelected: true,
          value: dateUtils.adquirirIntervaloDeHoje(),
        },
        {
          id: "btn-filtro-intervalo-semana",
          label: "Esta semana",
          isSelected: false,
          value: dateUtils.adquirirIntervaloSemana(),
        },
        {
          id: "btn-filtro-intervalo-mes",
          label: "Este mês",
          isSelected: false,
          value: dateUtils.adquirirIntervaloMes(),
        },
      ]
      buttonSelectorConfig.label = label
      buttonSelectorFiltro.configuracoesDeInput = buttonSelectorConfig;
      return buttonSelectorFiltro
}

export const defaultCheckboxFieldsStatusFilter = (key, id = 'checkbox-fields-status-filtro', label = "Status") => {
    if (!key) return;
    const checkboxFields = new ConfigCampoFiltro(
        new configDeCampos(id, 'checkbox-fields', key, key)
      );
      checkboxFields.containerOptions.containerClasses = {
        ...checkboxFields.containerOptions.containerClasses,
        'is-offset-4': false,
        'is-3': false,
        'is-narrow': true,
        'is-12-mobile': true
      }
      const checkboxFieldsConfig = new InputCheckboxFieldsConfig(checkboxFields.configuracoesDeInput);
      checkboxFieldsConfig.options = [
        {
          id: "checkbox-status-aguardando-dados",
          label: "Aguardando dados",
          isSelecionada: true,
          valor: `9`,
        },
        {
          id: "checkbox-status-aguardando-conferencia",
          label: "A conferir",
          isSelecionada: true,
          valor: `10`,
        },
        {
          id: "checkbox-status-a-fazer",
          label: "A fazer",
          isSelecionada: true,
          valor: `1`,
        },
        {
          id: "checkbox-status-atrasada",
          label: "Atrasada",
          isSelecionada: true,
          valor: `5`,
        },
        {
          id: "checkbox-status-paralisado",
          label: "Paralisado",
          isSelecionada: true,
          valor: `8`,
        },
        {
          id: "checkbox-status-concluida",
          label: "Concluído",
          isSelecionada: false,
          valor: `2`,
        }
      ];
      checkboxFieldsConfig.label = label
      checkboxFields.configuracoesDeInput = checkboxFieldsConfig

      return checkboxFields
}

export const defaultButtonFiltrar = (key, id = "button-filtrar", func = () => {}, label = "Filtrar") => {
    if (!key) return;
    const campoBotao = new ConfigCampoFiltro(new configDeCampos(id, 'button', key, key))
      campoBotao.containerOptions.containerClasses = {
        ...campoBotao.containerOptions.containerClasses,
        'is-3': false,
        'is-flex is-justify-content-flex-end': true,
        'is-12-mobile': true
      }
      const inputBotaoConfig = new InputButtonConfig('button-input', `button-${key}`, label, 'is-primary', func);
      campoBotao.configuracoesDeInput = inputBotaoConfig;

      return campoBotao
}

export const defaultPeriodoDataConclusaoField = (key, id = "periodo-conclusao-interval-filter", label = "Data de conclusão") => {
    if (!key) return
    const periodoFiltro = new ConfigCampoFiltro(
        new configDeCampos(id, 'periodo', key, key, formatPeriodoConclusao)
      );
      periodoFiltro.containerOptions.containerClasses = {
        ...periodoFiltro.containerOptions.containerClasses,
        'is-3': false,
        'is-5': true,
        'is-12-mobile': true
      }
      periodoFiltro.configuracoesDeInput.label = label;

      return periodoFiltro
}

export const defaultSelectResponsavelField = (key, id = 'select-responsavel-filtro', label = "Responsável", options = []) => {
    if (!key) return;
    const selectFiltro = new ConfigCampoFiltro(
        new configDeCampos(id, 'select', key, key)
      );
      selectFiltro.containerOptions.containerClasses = {
        ...selectFiltro.containerOptions.containerClasses,
        'is-3': false,
        'is-4': true,
        'is-12-mobile': true
      }
      selectFiltro.configuracoesDeInput.label = label;
      selectFiltro.configuracoesDeInput.placeholder = "Selecione";
      selectFiltro.configuracoesDeInput.options = options;
      selectFiltro.configuracoesDeInput.canClear = true;
      selectFiltro.configuracoesDeInput.required = false;
      return selectFiltro
}